import axios from 'axios';

import { PAQUETES } from '../actions/types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const obtenerPaquete = (id) => async dispatch => {
    if(id){
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }

        const body = JSON.stringify({ id });

        try {
            await dispatch(changeLoader(true));
            const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/paquetes/detalles`, body, config);

            await dispatch({
                type: PAQUETES.DETALLES,
                payload: res.data.paquete
            });
        } catch (error) {
            if(error?.response?.data?.msg) {
                await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
            }
        } finally {
            await dispatch(changeLoader(false));
        }
    } else {
        dispatch({
            type: PAQUETES.DETALLES,
            payload: null
        });
    }
}

export const buscarPaquetes = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/paquetes/listar`, config);

        await dispatch({
            type: PAQUETES.BUSCAR,
            payload: res.data.contrataciones_paquetes
        });
    } catch (error) {
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}
